import { render, staticRenderFns } from "./JLnbRouterLinkedMenu.vue?vue&type=template&id=42e6b3b2&"
import script from "./JLnbRouterLinkedMenu.vue?vue&type=script&lang=js&"
export * from "./JLnbRouterLinkedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListTile,VListTileContent,VListTileTitle})
